<template>
	<view class="container">
	    <view class="index-banner">
			<swiper class="carousel" indicator-dots="true" autoplay="true" interval="3000">
				<swiper-item v-for="(item, index) in bannerImgs" :key="index" class="carousel-item">
					<image :src="item.img" />
				</swiper-item>
			</swiper>
	    </view>
	    <view class="search-type bgf">
			<view class="tab-lists">
				<text @tap="tapType" class="tab-item" :class="{active:stype =='number'}" data-type="number" data-txt="可输入OE编码或者参考编码">号码</text>
				<text @tap="tapType" class="tab-item" :class="{active:stype =='vin'}" data-type="vin" data-txt="请输入17位的车架号">车架号</text>
				<text @tap="tapType" class="tab-item" :class="{active:stype =='model'}" data-type="model" data-txt="请选择车型" >车型</text>
				<text @tap="tapType"  class="tab-item" :class="{active:stype =='item'}" data-type="item" data-txt="请输入关键字" >配件</text>
			</view>
			<form @submit="mainSearch">
				<view class="input-btn mui-input-row">
					<input type="text" name="type" style="display:none" :value="stype"/>
					<view class="input mui-input-row">
						<input type="text" name="keyword" maxlength="50" class="input-btn-txt" value="8K0 407" :placeholder="stypeTxt" :confirm-hold="true" confirm-type="search"/>
						<view class="mui-icon mui-icon-clear mui-hidden"></view>
					</view>
					<block v-if="stype == 'vin'">
						<view class="vin-camera" @tap="vinCamera">
						   <image src="/static/active/icon-camera.png"></image>
						</view>
					</block>
					<view class="btns"><button form-type="submit" class="btn">搜索</button></view>
				</view>
			</form>
		</view>
		<view>
			<uni-popup ref="popup" type="center">
				<view style="background-color: #fff;padding: 30rpx;">
					<text>用户未开启相机权限, 开启权限后方可使用相机</text>
					<button @tap="openSet" style="background-color: #df0707;width: 150rpx;line-height: 60rpx;font-size: 30rpx;color: #fff;">去授权</button>
				</view>
			</uni-popup>
			<uni-popup ref="h5_popup" type="center">
				<view style="background-color: #fff;padding: 30upx;border-radius: 10upx;">					
					<view style="border-bottom: 1upx solid #ccc;padding-bottom: 10upx;" @tap="takeVinPhoto">拍照VIN</view>
					<view style="margin-top: 10upx;" @tap="chooseImgUpload">上传VIN图片</view>
				</view>
			</uni-popup>
		</view>
	</view>
</template>

<script>
	const app = getApp();
	export default {
		data() {
			return {
				stype: 'number',
				stypeTxt: '可输入OE编码或者参考编码',
				wordfocus: false,
				bannerImgs: [],
				indicatorDots: true,
				autoplay: true,
				interval: 3000,
				camera: {}
			}
		},
		onLoad() {
			var that = this;
			app.getApi('GET', 'gzh/getGzhInfo', {}, 1, function (data) {
			  that.bannerImgs = app.globalData.shopBase.aps_banner;
			});
		},
		methods: {
			tapType: function(e){
				var that = this;
				if(e.target.dataset.type == 'model'){
				  uni.navigateTo({ url: '/pages/model/brand' });
				} else{
					that.stype = e.target.dataset.type,
					that.stypeTxt = e.target.dataset.txt;
					that.wordfocus = e.target.dataset.type == 'model' ? false : true;
				}
			},
			mainSearch: function(e){
				var that = this;
				var data = e.detail.value;
				var word = data.keyword.trim();
				switch (data.type) 
				{
				  case 'vin':
					if (!(/^[0-9a-zA-Z]{17}$/).test(word)) {
					  uni.showToast({ title: '请输入正确的17位车架号', icon: 'none' });
					  that.wordfocus = true;
					  return false;
					}
					uni.navigateTo({ url: '/pages/item/vinSearch?vin=' + word });
				  break;
				  case 'model':
					return false;
				  break;
				  default:
					if (word == '') {
					  uni.showToast({ title: '请输入搜索内容', icon: 'none' });
					  that.wordfocus = true;
					  return false;
					}
					uni.navigateTo({ url: '/pages/item/search?type=' + data.type + '&keyword=' + word });
					break;
				}
			},
			takePhoto() {
				const ctx = uni.createCameraContext()
				ctx.takePhoto({
				  quality: 'high',
				  success: (res) => {
					
				  }
				})
			},
			vinCamera() {
				// #ifdef MP-WEIXIN
				uni.getSetting({
				    success: response => {
				        if (!response.authSetting['scope.camera']) {
							this.$refs.popup.open('center')
				        } else {
							uni.navigateTo({url: '/pages/index/camera'});
						}
				    },
				    fail: res => {
						console.log('配置获取失败', res)
				    }
				})
				// #endif
				
				// #ifdef H5
				let ua = navigator.userAgent.toLowerCase()
				if (ua.search(/MicroMessenger/i) > -1 || ua.search(/mqqbrowser/i) >-1) {
					this.$refs.h5_popup.open('center')
				} else {
					let that = this
					uni.chooseImage({
						count: 1,
						sizeType: ['compressed'],
						sourceType: ['album'],
						success: function (res) {
							that.getVinRes(res.tempFilePaths[0])
						}
					});
				}
				// #endif
			},
			openSet() {
				uni.openSetting({
					success(res) {
						if (res.authSetting['scope.camera']) {
							uni.navigateTo({url: '/pages/index/camera'});
						} else {
							uni.showToast({
							  title: '相机权限未开启',
							  icon: 'error'
							})
						}
					},
					fail(err) {
						console.log('开启设置失败', err)
					}
				})
			},
			img2base64(url)
			{
				return new Promise((reslove,reject) => {
					uni.request({
						url: url,
						method: 'GET',
						responseType: 'arraybuffer',
						success(res) {
							let base64 = 'data:image/jpeg;base64,' + uni.arrayBufferToBase64(res.data)
							reslove(base64)
						},
						fail(err) {
							reject('图片转换失败')
						}
					})
				})
			},
			getVinRes(img)
			{
				uni.setStorageSync('vinBig', img);

				this.img2base64(img).then(res => {
					let base64 = res
					let data = {img:base64}
					app.getApi('POST','data/vinOcr', data, 1, function(result){
						if (result.vin.length > 0) {
							uni.redirectTo({url: '/pages/index/cameraData?isc=0&isad=0&data='+JSON.stringify(result)+'&url='+img});
						} else {
							uni.redirectTo({url: '/pages/index/fetchData?isc=0&url='+img});
						}
					})
				})
			},
			chooseImgUpload() {
				let that = this
				uni.chooseImage({
					count: 1,
					sizeType: ['compressed'],
					sourceType: ['album'],
					success: function (res) {
						that.getVinRes(res.tempFilePaths[0])
					}
				});
			},
			takeVinPhoto() {
				let that = this
				uni.chooseImage({
					count: 1,
					sizeType: ['compressed'],
					sourceType: ['camera'],
					success: function (res) {
						that.getVinRes(res.tempFilePaths[0])
					}
				});
			}
		}
	}
</script>

<style>
.index-banner{
  dispaly: fixed;
  width: 100%;
}
swiper{
  width: 100%;
  height: 416.7rpx;
}
swiper image{
  width: 100%;
  height: 416.7rpx;
}
.search-type{
  dispaly: fixed;
  width: 100%;
  padding:25px 0;
}
.tab-lists {
    width: 100%;
    box-sizing: border-box;
    padding: 0 3%;
    margin-bottom:12px;
}
.tab-item {
    line-height: 28px;
    display: table-cell;
    width: 1%;
    text-align: center;
    font-size:16px; 
}
.tab-item.active {
    color: #fff;
    background: url(https://gzh.paojd.cn/images/hbg03.jpg)no-repeat right 0 #df0707;
    transform: skewX(-15deg);
}
.search-type .input-btn{padding: 0 3%;}

.vin-camera {
  position: absolute;
  z-index: 2;
}
</style>
